// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=ChatFooter|schemaHash=3544fccce4f67735ac4ba1ff5a2b78b300ee0e2a

import { setDefinedValue } from '@myre/common-primitives';

export function parseChatFooterFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'show', _data.show);
  setDefinedValue(result, 'text', _data.text);
  setDefinedValue(result, 'linkUrl', _data.linkUrl);
  setDefinedValue(result, 'linkText', _data.linkText);

  return result;
}

export function parseChatFooterToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'show', _data.show);
  setDefinedValue(result, 'text', _data.text);
  setDefinedValue(result, 'linkUrl', _data.linkUrl);
  setDefinedValue(result, 'linkText', _data.linkText);

  return result;
}
